import tw, { styled } from 'twin.macro'

export const Message = styled.span([
  tw`inline-block w-full text-xs text-feedback-danger-medium font-montserrat-medium mt-1`,
])
